import React, { useState } from 'react';
import { Phone, Mail, MapPin, Instagram, Facebook } from 'lucide-react';
import { LegalModal, LegalDocKey } from './LegalModal';
export function Footer() {
  const [openDoc, setOpenDoc] = useState<LegalDocKey | null>(null);
  return <footer className="bg-ink pt-24 pb-12" data-id="element-52">
      <div className="container mx-auto px-8 lg:px-12" data-id="element-53">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-16 mb-20" data-id="element-54">
          {/* Brand */}
          <div className="lg:col-span-1" data-id="element-55">
            <img src="https://cdn.magicpatterns.com/uploads/qRjCzRZKtzH13Qu1B2aj1Z/LogoPNG.png" alt="NÍTIDO PRO" className="w-28 mb-8 brightness-0 invert opacity-90" data-id="element-56" />
            <p className="text-concrete/60 font-light text-sm leading-relaxed mb-8" data-id="element-57">
              Premium architectural-grade cleaning services. We don't just
              clean, we reset your spaces. Zero drama.
            </p>
            <div className="flex gap-6" data-id="element-58">
              <a href="#" className="text-concrete/60 hover:text-lime transition-colors" data-id="element-59">
                <Instagram size={20} strokeWidth={1.5} data-id="element-60" />
              </a>
              <a href="#" className="text-concrete/60 hover:text-lime transition-colors" data-id="element-61">
                <Facebook size={20} strokeWidth={1.5} data-id="element-62" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-63">
            <h4 className="text-paper text-xs font-medium mb-8 uppercase tracking-[0.2em]" data-id="element-64">
              Quick Links
            </h4>
            <ul className="space-y-4" data-id="element-65">
              {['Services', 'Difference', 'Pricing', 'How it Works', 'Get a Quote'].map(link => <li key={link} data-id="element-66">
                  <a href={`#${link.toLowerCase().replace(/\s+/g, '-')}`} className="text-concrete/60 hover:text-paper transition-colors font-light text-sm" data-id="element-67">
                    {link}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Service Areas */}
          <div data-id="element-68">
            <h4 className="text-paper text-xs font-medium mb-8 uppercase tracking-[0.2em]" data-id="element-69">
              Service Areas
            </h4>
            <ul className="space-y-4" data-id="element-70">
              {['Orlando', 'Kissimmee', 'Davenport', 'Lake Nona', 'Winter Garden', 'Celebration'].map(area => <li key={area} className="text-concrete/60 font-light text-sm" data-id="element-71">
                  {area}
                </li>)}
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-72">
            <h4 className="text-paper text-xs font-medium mb-8 uppercase tracking-[0.2em]" data-id="element-73">
              Contact Us
            </h4>
            <ul className="space-y-6" data-id="element-74">
              <li data-id="element-75">
                <a href="tel:9545498931" className="flex items-center gap-4 text-concrete/60 hover:text-paper transition-colors font-light text-sm" data-id="element-76">
                  <Phone size={16} className="text-lime" strokeWidth={1.5} data-id="element-77" />
                  954-549-8931
                </a>
              </li>
              <li data-id="element-78">
                <a href="mailto:mynitidopro@gmail.com" className="flex items-center gap-4 text-concrete/60 hover:text-paper transition-colors font-light text-sm" data-id="element-79">
                  <Mail size={16} className="text-lime" strokeWidth={1.5} data-id="element-80" />
                  mynitidopro@gmail.com
                </a>
              </li>
              <li className="flex items-start gap-4 text-concrete/60 font-light text-sm" data-id="element-81">
                <MapPin size={16} className="text-lime flex-shrink-0 mt-1" strokeWidth={1.5} data-id="element-82" />
                <span className="leading-relaxed" data-id="element-83">
                  Serving Central Florida
                  <br data-id="element-84" />
                  Orlando & Surrounding Areas
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-concrete/10 pt-8 flex flex-col md:flex-row items-center justify-between gap-6" data-id="element-85">
          <p className="text-concrete/40 text-xs font-light tracking-wide" data-id="element-86">
            &copy; {new Date().getFullYear()} NÍTIDO PRO. All rights reserved.
          </p>
          <div className="flex gap-8 text-xs text-concrete/40 font-light tracking-wide" data-id="element-87">
            <button type="button" onClick={() => setOpenDoc('privacy')} className="hover:text-paper transition-colors" data-id="element-88">
              Privacy Policy
            </button>
            <button type="button" onClick={() => setOpenDoc('terms')} className="hover:text-paper transition-colors" data-id="element-89">
              Terms of Service
            </button>
          </div>
        </div>
      </div>

      <LegalModal doc={openDoc} onClose={() => setOpenDoc(null)} data-id="element-90" />
    </footer>;
}